import { Stack } from "@mui/material";
import * as React from "react";
import { isEqual } from "lodash";

import { generateSide } from "../../../lib/generateSide";
import { IXFooterProps } from "../../../utils/interfaces/common/XFooter.interfaces";
import { useXoraiaValue } from "../../../hooks/useXoraia";
import { TCoreXElement } from "../../../utils/types/core/CoreXelement";
import { useXCommonChildrenValue } from "../../../hooks/useXCommon";

const compareProps = (prevProps: any, nextProps: any) => {
  return isEqual(prevProps, nextProps);
};

const XFooterCore: TCoreXElement<IXFooterProps> = React.memo(
  ({ props, devProps, DynamicXElement }) => {
    const { env } = useXoraiaValue();

    const xFooterChildren = useXCommonChildrenValue("FOOTER");

    const children = DynamicXElement
      ? xFooterChildren.map((child, i) => (
          <DynamicXElement
            key={i}
            child={child}
            index={child.config?.index ?? ""}
            position={i}
            hierachy="XFooter"
          />
        ))
      : [];

    const { padding, margin, bgColor, ...sx } = props;

    return (
      <Stack
        {...(env === "dev" && devProps)}
        sx={{
          width: "100%",
          bgcolor: bgColor,
          ...sx,
          padding: generateSide("padding", padding),
          margin: generateSide("margin", margin),
        }}
      >
        {children}
        {children.length === 0 && (
          <p
            style={{
              textAlign: "center",
              padding: 20,
              backgroundColor: "rgba(0,0,0,0.1)",
            }}
          >
            Ajouter le pied de page
          </p>
        )}
        {/* <Divider />
        <Typography
          textAlign="center"
          py={1.5}
          fontWeight={600}
          variant="caption"
          color="GrayText"
          bgcolor="#EFEFEF"
          sx={{ "& a": { color: SECONDARY_COLOR, textDecoration: "none" } }}
        >
          Powered by{" "}
          <a href="https://xoraia.com" target="_blank">
            Xoraia
          </a>{" "}
          a baby of{" "}
          <a href="https://drosarl.com" target="_blank">
            DRO SARL
          </a>
        </Typography> */}
      </Stack>
    );
  },
  compareProps
);

export default XFooterCore;
